/**
 * Full Mission Assessment Generation (AZ-393): one Assessment Section per
 * Mission Assessment form area, generated in two waves — structured picks
 * first, then prose with the picks as context.
 */
export var FullAssessmentSectionId;
(function (FullAssessmentSectionId) {
    FullAssessmentSectionId["CAPABILITIES"] = "CAPABILITIES";
    FullAssessmentSectionId["COMMUNITIES"] = "COMMUNITIES";
    FullAssessmentSectionId["EFFECTS"] = "EFFECTS";
    FullAssessmentSectionId["GENERAL_NOTES"] = "GENERAL_NOTES";
    FullAssessmentSectionId["HURDLES"] = "HURDLES";
    FullAssessmentSectionId["INTERCHANGEABLE"] = "INTERCHANGEABLE";
    FullAssessmentSectionId["INTEROPERABLE"] = "INTEROPERABLE";
    FullAssessmentSectionId["KILL_CHAINS"] = "KILL_CHAINS";
    FullAssessmentSectionId["PHASES"] = "PHASES";
    FullAssessmentSectionId["RECOMMENDED_SERVICES"] = "RECOMMENDED_SERVICES";
    FullAssessmentSectionId["RECOMMENDED_TECHNOLOGY_USES"] = "RECOMMENDED_TECHNOLOGY_USES";
    FullAssessmentSectionId["RISKS"] = "RISKS";
    FullAssessmentSectionId["STRATEGIC"] = "STRATEGIC";
    FullAssessmentSectionId["SUSTAINMENT"] = "SUSTAINMENT";
    FullAssessmentSectionId["TASK_RECOMMENDATIONS"] = "TASK_RECOMMENDATIONS";
    FullAssessmentSectionId["THREATS"] = "THREATS";
})(FullAssessmentSectionId || (FullAssessmentSectionId = {}));
/**
 * Wave 1 = structured picks (parallel); wave 2 = prose generated with the
 * wave-1 outputs in context (parallel within the wave).
 */
export const FULL_ASSESSMENT_SECTION_WAVES = {
    [FullAssessmentSectionId.CAPABILITIES]: 1,
    [FullAssessmentSectionId.COMMUNITIES]: 1,
    [FullAssessmentSectionId.EFFECTS]: 1,
    [FullAssessmentSectionId.GENERAL_NOTES]: 2,
    [FullAssessmentSectionId.HURDLES]: 2,
    [FullAssessmentSectionId.INTERCHANGEABLE]: 1,
    [FullAssessmentSectionId.INTEROPERABLE]: 1,
    [FullAssessmentSectionId.KILL_CHAINS]: 1,
    [FullAssessmentSectionId.PHASES]: 1,
    [FullAssessmentSectionId.RECOMMENDED_SERVICES]: 1,
    [FullAssessmentSectionId.RECOMMENDED_TECHNOLOGY_USES]: 1,
    [FullAssessmentSectionId.RISKS]: 2,
    [FullAssessmentSectionId.STRATEGIC]: 2,
    [FullAssessmentSectionId.SUSTAINMENT]: 2,
    [FullAssessmentSectionId.TASK_RECOMMENDATIONS]: 1,
    [FullAssessmentSectionId.THREATS]: 2,
};
/**
 * Canonical display/dispatch order, mirroring the Mission Assessment form.
 */
export const FULL_ASSESSMENT_SECTION_ORDER = [
    FullAssessmentSectionId.CAPABILITIES,
    FullAssessmentSectionId.COMMUNITIES,
    FullAssessmentSectionId.KILL_CHAINS,
    FullAssessmentSectionId.RECOMMENDED_SERVICES,
    FullAssessmentSectionId.RECOMMENDED_TECHNOLOGY_USES,
    FullAssessmentSectionId.TASK_RECOMMENDATIONS,
    FullAssessmentSectionId.EFFECTS,
    FullAssessmentSectionId.INTEROPERABLE,
    FullAssessmentSectionId.INTERCHANGEABLE,
    FullAssessmentSectionId.PHASES,
    FullAssessmentSectionId.HURDLES,
    FullAssessmentSectionId.THREATS,
    FullAssessmentSectionId.STRATEGIC,
    FullAssessmentSectionId.RISKS,
    FullAssessmentSectionId.SUSTAINMENT,
    FullAssessmentSectionId.GENERAL_NOTES,
];
export const FULL_ASSESSMENT_SECTION_LABELS = {
    [FullAssessmentSectionId.CAPABILITIES]: 'Joint Capabilities',
    [FullAssessmentSectionId.COMMUNITIES]: 'Functional Communities',
    [FullAssessmentSectionId.EFFECTS]: 'Effects',
    [FullAssessmentSectionId.GENERAL_NOTES]: 'General Notes',
    [FullAssessmentSectionId.HURDLES]: 'Hurdles',
    [FullAssessmentSectionId.INTERCHANGEABLE]: 'Interchangeable Technologies',
    [FullAssessmentSectionId.INTEROPERABLE]: 'Interoperable Technologies',
    [FullAssessmentSectionId.KILL_CHAINS]: 'Kill Chain Elements',
    [FullAssessmentSectionId.PHASES]: 'Phases of Operations',
    [FullAssessmentSectionId.RECOMMENDED_SERVICES]: 'Recommended Services',
    [FullAssessmentSectionId.RECOMMENDED_TECHNOLOGY_USES]: 'Recommended Technology Uses',
    [FullAssessmentSectionId.RISKS]: 'Risks and Issues',
    [FullAssessmentSectionId.STRATEGIC]: 'Strategic and Operational Alignment',
    [FullAssessmentSectionId.SUSTAINMENT]: 'Sustainment Considerations',
    [FullAssessmentSectionId.TASK_RECOMMENDATIONS]: 'Task Recommendations',
    [FullAssessmentSectionId.THREATS]: 'Threats and Responses',
};
export var FullAssessmentSectionStatus;
(function (FullAssessmentSectionStatus) {
    FullAssessmentSectionStatus["COMPLETED"] = "completed";
    FullAssessmentSectionStatus["FAILED"] = "failed";
    FullAssessmentSectionStatus["QUEUED"] = "queued";
    FullAssessmentSectionStatus["STREAMING"] = "streaming";
})(FullAssessmentSectionStatus || (FullAssessmentSectionStatus = {}));
